var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 100,
    viewBox: "0 0 124 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0816 2.60897L3.94811 29.0214C-3.24281 32.6168 0.629138 39.7837 5.74581 42.2968C18.7907 48.704 47.1207 62.6523 56.0816 67.1881L56.1675 67.2316C60.9283 69.6416 61.5126 69.9373 67.8358 67.1881L115.129 43.8179V64.2841C115.129 70.7835 123.703 71.8898 123.98 64.2841C124.026 57.462 123.98 42.4085 123.98 36.7654C123.98 31.0957 120.937 29.31 118.448 28.0534C104.205 20.8626 74.1416 5.70655 67.8358 2.60897C61.53 -0.488617 59.1237 1.0878 56.0816 2.60897Z",
    fill: "#2F3338"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5271 77.0068L105.588 58.4766V76.3153C105.588 82.953 100.609 86.5484 98.1201 87.5164C89.6848 90.5126 71.68 96.8922 67.1443 98.4409C62.6085 99.9897 57.6026 98.7175 55.6666 97.8878C49.6743 95.9057 35.7812 91.2778 28.1479 88.6227C20.5146 85.9676 18.0531 80.1873 18.0531 77.0068V58.6148C28.1479 63.6392 49.4162 74.2134 53.7306 76.3153C60.5066 79.6164 63.8255 78.8045 68.5271 77.0068Z",
    fill: "#2F3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.9734331781e1d5315110d6f917e3e5ca.svg";
export { ForwardRef as ReactComponent };